/**
 * Mobile Navigation - Service
 * Manages the navigation items and UI state
 */

import { Injectable, signal, computed } from '@angular/core';
import { IMobileNavItem, IMobileNavState } from '../models/mobile-nav.model';

@Injectable({
  providedIn: 'root'
})
export class MobileNavService {
  private readonly navItemsSignal = signal<IMobileNavItem[]>([
    { id: 'dashboard', label: 'Dashboard', icon: 'bi-speedometer2', route: '/dashboard' },
    { id: 'courts', label: 'Canchas', icon: 'bi-geo-alt', route: '/courts' },
    { id: 'reservations', label: 'Reservas', icon: 'bi-calendar-check', route: '/reservations' },
    { id: 'members', label: 'Socios', icon: 'bi-people', route: '/members' },
    { id: 'pricing', label: 'Precios', icon: 'bi-tag', route: '/pricing', priority: 10 },
    { id: 'reports', label: 'Reportes', icon: 'bi-graph-up', route: '/reports', priority: 10 },
    { id: 'competitions', label: 'Competiciones', icon: 'bi-trophy', route: '/competitions', priority: 10 },
    { id: 'settings', label: 'Configuración', icon: 'bi-gear', route: '/settings', priority: 10 },
    { id: 'login', label: 'Cerrar Sesión', icon: 'bi-box-arrow-right', route: '/login', priority: 10 }
  ]);

  private readonly stateSignal = signal<IMobileNavState>({
    isMoreOpen: false,
    activeItemId: null
  });

  // Computed views
  readonly mainNavItems = computed<IMobileNavItem[]>(() => 
    this.navItemsSignal().filter(item => !item.priority || item.priority < 10)
  );

  readonly moreNavItems = computed<IMobileNavItem[]>(() => 
    this.navItemsSignal().filter(item => item.priority && item.priority >= 10)
  );

  readonly isMoreOpen = computed<boolean>(() => this.stateSignal().isMoreOpen);

  /**
   * Toggle the "More" menu
   */
  toggleMore(): void {
    this.stateSignal.update(state => ({
      ...state,
      isMoreOpen: !state.isMoreOpen
    }));
  }

  /**
   * Close the "More" menu
   */
  closeMore(): void {
    this.stateSignal.update(state => ({
      ...state,
      isMoreOpen: false
    }));
  }

  /**
   * Set active item
   */
  setActiveItem(id: string): void {
    this.stateSignal.update(state => ({
      ...state,
      activeItemId: id,
      isMoreOpen: false // Close menu when item selected
    }));
  }
}
